import { render, staticRenderFns } from "./addContract.vue?vue&type=template&id=6fdc2491&scoped=true"
import script from "./addContract.vue?vue&type=script&lang=js"
export * from "./addContract.vue?vue&type=script&lang=js"
import style0 from "./addContract.vue?vue&type=style&index=0&id=6fdc2491&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdc2491",
  null
  
)

export default component.exports